import React, { useEffect, useState } from "react";
import { useUploadDocuments } from "./store";
import CardDiv from "modules/common/card-div/CardDiv";
import { baseURL } from "../../../config/index";
import { Placeholder } from "react-bootstrap";
import NoData from "assets/svgs/no_data/NoData";
import moment from "moment";

function UploadDocuments({ case_id }) {
  const [docData, setDocData] = useState([]);
  const { fetchUploadDocuments, uploadDocumentsData, isLoading } =
    useUploadDocuments();
  useEffect(() => {
    fetchUploadDocuments(case_id);
  }, [case_id]);

  useEffect(() => {
    setDocData(uploadDocumentsData);
  }, [uploadDocumentsData]);
  return (
    <div className="">
      <CardDiv
        title={
          <div className="d-flex p-2 justify-content-between">
            <div>
              <span>File name (click to download)</span>
            </div>
            <div>
              <a
                className="bg-success text-white p-2 rounded shadow"
                target="_blank"
                rel="noopener noreferrer"
                href={`${baseURL.FORMV2S_URL}pages/medicaldocs/${case_id}`}
              >
                Upload More
              </a>
            </div>
          </div>
        }
        component={
          <div
            style={{ height: "20.5rem", overflowY: "scroll" }}
            className="scrollable-container"
          >
            {!isLoading && !docData && (
              <Placeholder xs={4} bg="success" animation="wave" />
            )}
            {!isLoading && docData && docData.length ? (
              docData
                .sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
                .map((doc) => {
                  return (
                    <div>
                      <a
                        href={doc.link}
                        download={doc.link}
                        className="text-success fw-bold my-2"
                      >
                        {doc.document.split("/").pop()} ({" "}
                        <em>
                          {moment(doc.created_at).format("YYYY/MM/DD HH:mm")}
                        </em>{" "}
                        )
                      </a>
                    </div>
                  );
                })
            ) : (
              <Placeholder xs={4} bg="success" animation="wave" />
            )}
            {!isLoading && !docData.length && (
              <div className="d-flex gap-3 justify-content-center align-items-center">
                <h3 className="mb-0">No Data available</h3>
                <NoData />
              </div>
            )}
          </div>
        }
      />
    </div>
  );
}

export default UploadDocuments;
